import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import store from "@/store";
export default {
  name: "MessageBell",
  computed: {
    // 是否显示铃铛（需要 VIEW_MESSAGE 权限）
    showMessageIcon() {
      const perms = store.getters.permissions || [];
      return perms.some(e => e.code === "VIEW_MESSAGE");
    },
    // 未读角标文字（""、"1"…"99"、"99+"），数据来自全局待办统计轮询
    unreadMessages() {
      const unread = this.$store.getters.pendingStat.unreadMessageCount || 0;
      if (unread === 0) {
        return "";
      }
      if (unread < 100) {
        return `${unread}`;
      }
      return "99+";
    }
  },
  methods: {
    /**
     * 铃铛点击 → 跳转通知中心整页
     * 已在 /message 时不重复 push
     */
    goToNotificationCenter() {
      if (!this.$route.path.startsWith("/message")) {
        this.$router.push("/message");
      }
    }
  }
};